module.exports = __webpack_public_path__ + "static/media/dre1.png.ef03e652.jpg";